
import React from 'react'
import { mdx } from '@mdx-js/react'
export const readingTime = {"text":"5 min read","minutes":4.145,"time":248700,"words":829}
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The thing that is unique about this document is that this will contain everything required for competitive programming. People generally have confusion about where to start. We are completely self learned. So, we know where students generally face issues during beginning. This document will cover every topics required in competitive programming. We only assume that you know basic mathematics. The things will eventually get easy as you will move forward in your learning journey. People generally says everything is available on the web for free. Obviously, this is true. But, you need to know form where to learn. We will fulfill that gap through this document. Just follow the instructions step by step. We will also solve lot of good problems. We will also provide you some books at last, in case you want to delve deep.`}</p>
    <h2 {...{
      "id": "is-this-document-for-you"
    }}>{`Is this document for you?`}</h2>
    <p>{`Are you interested in problem solving or coding or competitions or mathematics?
If your answer is yes, get ready to be “CodeZoned​”. Make sure to contribute on our Github
repository. You can at least star our document or make your first pull request through our
repository.
If you are senior, experienced in competitive programming, we urge you to help younger
budding programmers by contributing to this document. You can also send your suggestions
directly to us anytime.`}</p>
    <h2 {...{
      "id": "disclaimer"
    }}>{`Disclaimer`}</h2>
    <p>{`All the documents, books, courses and links provided in this document are freely available on
the web. We are just helping people find them easily.`}</p>
    <h2 {...{
      "id": "introduction"
    }}>{`Introduction`}</h2>
    <p>{`What is `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Competitive_programming",
        "title": "Competitive Programming"
      }}>{`Competitive Programming`}</a>{`?`}</p>
    <p>{`List of `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/List_of_programming_contests",
        "title": "Programming Contests"
      }}>{`Programming Contests`}</a>{`.`}</p>
    <p>{`Which programming language is best? See `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Google_Code_Jam",
        "title": "Google Code Jam"
      }}>{`Google Code Jam`}</a>{` stats
`}<a parentName="p" {...{
        "href": "https://www.go-hero.net/jam/17/languages"
      }}>{`here`}</a>{`. Let me tell you, C++ is the best language for competitive
programming. Stick with it. JAVA is also good. Some people say
language has no effect on code. This depends on `}<a parentName="p" {...{
        "href": "https://stackoverflow.com/questions/3380993/why-do-programming-competition-contestants-use-c-and-java"
      }}>{`person to person`}</a>{`.
Advantages of C++ in competitive programming: See the topic Python
v/s C in the “LinksPDF.pdf” file in our repository.`}</p>
    <p>{`Learn `}<a parentName="p" {...{
        "href": "https://www.youtube.com/playlist?list=PLAE85DE8440AA6B83",
        "title": "C++ Tutorial"
      }}>{`C++`}</a>{` from Bucky of The Boston School. Solve basic problems on`}</p>
    <p><a parentName="p" {...{
        "href": "http://www.codeabbey.com/",
        "title": "Codeabbey"
      }}>{`Codeabbey`}</a>{`. Now if you have completed this step. Solve some more
problems on `}<a parentName="p" {...{
        "href": "https://projecteuler.net/"
      }}>{`Project Euler`}</a>{`, not all. Now you are ready to go.`}</p>
    <h2 {...{
      "id": "programming-techniques"
    }}>{`Programming Techniques`}</h2>
    <p><a parentName="p" {...{
        "href": "https://www.khanacademy.org/computing/computer-science/algorithms/recursive-algorithms/a/recursion"
      }}>{`Recursive algorithms`}</a>{` (`}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=mz6tAJMVmfM"
      }}>{`video`}</a>{`) (`}<a parentName="p" {...{
        "href": "https://www.topcoder.com/community/data-science/data-science-tutorials/an-introduction-to-recursion-part-1/"
      }}>{`topcoder`}</a>{`) (`}<a parentName="p" {...{
        "href": "https://www.hackerrank.com/domains/fp/fp-recursion"
      }}>{`problems`}</a>{`) (`}<a parentName="p" {...{
        "href": "https://www.geeksforgeeks.org/practice-questions-for-recursion/"
      }}>{`more problems`}</a>{`)
(`}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Backtracking"
      }}>{`backtracking`}</a>{` and some `}<a parentName="p" {...{
        "href": "https://www.geeksforgeeks.org/backtracking-algorithms/"
      }}>{`problems`}</a>{`)`}</p>
    <p><a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=NLKQEOgBAnw"
      }}>{`Bit Manipulation`}</a>{` (`}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Bit_manipulation"
      }}>{`read`}</a>{`) (`}<a parentName="p" {...{
        "href": "https://www.hackerrank.com/domains/algorithms/bit-manipulation"
      }}>{`solve`}</a>{`) (`}<a parentName="p" {...{
        "href": "https://www.geeksforgeeks.org/bits-manipulation-important-tactics/"
      }}>{`tricks`}</a>{`) (`}<a parentName="p" {...{
        "href": "https://github.com/czgdp1807/resourcesandproblems/blob/master/Hacker's%20Delight%20bit%20tricks2nd%20Edition.pdf"
      }}>{`book`}</a>{`)`}</p>
    <h2 {...{
      "id": "time-complexity"
    }}>{`Time Complexity`}</h2>
    <p>{`BigO Notation (`}<a parentName="p" {...{
        "href": "https://rob-bell.net/2009/06/a-beginners-guide-to-big-o-notation/"
      }}>{`read`}</a>{`) (advanced `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Big_O_notation"
      }}>{`read`}</a>{`) (`}<a parentName="p" {...{
        "href": "https://www.khanacademy.org/computing/computer-science/algorithms/asymptotic-notation/a/big-o-notation"
      }}>{`Khan Academy`}</a>{`) (`}<a parentName="p" {...{
        "href": "http://bigocheatsheet.com/"
      }}>{`cheat sheet`}</a>{`)
(`}<a parentName="p" {...{
        "href": "http://ssp.impulsetrain.com/big-o.html"
      }}>{`misconceptions`}</a>{`)`}</p>
    <p>{`Maximum subarray](`}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Maximum_subarray_problem"
      }}>{`https://en.wikipedia.org/wiki/Maximum_subarray_problem`}</a>{`), `}<a parentName="p" {...{
        "href": "https://www.geeksforgeeks.org/backtracking-set-3-n-queen-problem/"
      }}>{`N queens problem`}</a></p>
    <h2 {...{
      "id": "sorting-and-searching"
    }}>{`Sorting and Searching`}</h2>
    <p>{`Sorting (`}<a parentName="p" {...{
        "href": "http://sorting.at/"
      }}>{`visualize`}</a>{`) (`}<a parentName="p" {...{
        "href": "https://betterexplained.com/articles/sorting-algorithms/"
      }}>{`intution`}</a>{`) (`}<a parentName="p" {...{
        "href": "https://brilliant.org/wiki/sorting-algorithms/"
      }}>{`read`}</a>{`) (`}<a parentName="p" {...{
        "href": "http://www.cplusplus.com/reference/algorithm/sort/"
      }}>{`Sorting in C++`}</a>{`)
(`}<a parentName="p" {...{
        "href": "https://en.wikibooks.org/wiki/Algorithm_Implementation/Sorting"
      }}>{`Implementation`}</a>{`) (`}<a parentName="p" {...{
        "href": "https://www.geeksforgeeks.org/sorting-algorithms/"
      }}>{`Problems`}</a>{`) Read only Bubble, Merge, Counting
sort and sorting in O(n log n) time.`}</p>
    <p>{`Searching (`}<a parentName="p" {...{
        "href": "http://www.algomation.com/search?q=searching"
      }}>{`visualize`}</a>{`) (`}<a parentName="p" {...{
        "href": "https://www.geeksforgeeks.org/searching-algorithms/"
      }}>{`read and solve`}</a>{`) (`}<a parentName="p" {...{
        "href": "http://www.cplusplus.com/reference/algorithm/search/"
      }}>{`searching in C++`}</a>{`)`}</p>
    <p>{`An amazing `}<a parentName="p" {...{
        "href": "https://www.youtube.com/playlist?list=PLx3witYKF_5L3YKvXS3p3da-rqwghvW_Q"
      }}>{`playlist`}</a>{` of searching and sorting.`}</p>
    <p>{`Sweep Line algorithm (`}<a parentName="p" {...{
        "href": "https://www.topcoder.com/community/data-science/data-science-tutorials/line-sweep-algorithms/"
      }}>{`topcoder`}</a>{`)`}</p>
    <p>{`Event scheduling problem (`}<a parentName="p" {...{
        "href": "https://en.wikibooks.org/wiki/Algorithms/Greedy_Algorithms#Event_Scheduling_Problem"
      }}>{`wiki`}</a>{`) (`}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=Hq4VrKqAb88"
      }}>{`video`}</a>{`)`}</p>
    <p>{`Tasks and Deadlines problem (`}<a parentName="p" {...{
        "href": "http://www.techiedelight.com/job-sequencing-problem-deadlines/"
      }}>{`read`}</a>{`)`}</p>
    <h2 {...{
      "id": "data-structures"
    }}>{`Data Structures`}</h2>
    <p>{`Dynamic Arrays (vectors `}<a parentName="p" {...{
        "href": "https://medium.com/the-renaissance-developer/c-standard-template-library-stl-vector-a-pretty-simple-guide-d2b64184d50b"
      }}>{`read`}</a>{` and `}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=PocJ5jXv8No"
      }}>{`watch`}</a>{`) (`}<a parentName="p" {...{
        "href": "https://arne-mertz.de/2017/01/ranges-stl-next-level/"
      }}>{`iterators and ranges`}</a>{`)
(stacks, queues and deques `}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=IITnvmnfi_Y"
      }}>{`watch`}</a>{` and `}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=IITnvmnfi_Y"
      }}>{`pdf`}</a>{`)`}</p>
    <p>{`Set Structure (set and unordered_set `}<a parentName="p" {...{
        "href": "https://stackoverflow.com/questions/16075890/what-is-the-difference-between-set-and-unordered-set-in-c"
      }}>{`difference`}</a>{`, `}<a parentName="p" {...{
        "href": "http://cppisland.com/?p=457"
      }}>{`read`}</a>{`, `}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=PKE_Y9_gHMo"
      }}>{`watch`}</a>{`) (maps
`}<a parentName="p" {...{
        "href": "https://www.hackerrank.com/challenges/cpp-maps/problem"
      }}>{`read`}</a>{` and `}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=k-nSyfh6jr8"
      }}>{`watch`}</a>{`) (priority queue `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Priority_queue"
      }}>{`read`}</a>{` and `}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=wptevk0bshY"
      }}>{`watch`}</a>{`) (policy based
structures `}<a parentName="p" {...{
        "href": "http://codeforces.com/blog/entry/11080"
      }}>{`read`}</a>{`)`}</p>
    <p>{`See `}<a parentName="p" {...{
        "href": "http://bigocheatsheet.com/"
      }}>{`BigO Cheatsheet`}</a>{` for data structures comparison.`}</p>
    <p><a parentName="p" {...{
        "href": "https://www.cs.usfca.edu/~galles/visualization/Algorithms.html"
      }}>{`Visualisation`}</a>{` of different data structures.`}</p>
    <p>{`** Dynamic Programming`}</p>
    <p>{`Highly recommended watch (`}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=P8Xa2BitN3I"
      }}>{`1`}</a>{` and `}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=OQ5jsbhAv_M"
      }}>{`2`}</a>{`) and `}<a parentName="p" {...{
        "href": "https://www.topcoder.com/community/data-science/data-science-tutorials/dynamic-programming-from-novice-to-advanced/"
      }}>{`read`}</a>{` .`}</p>
    <p><a parentName="p" {...{
        "href": "http://thinking-intuitively.blogspot.in/2011/03/dynamic-programming.html"
      }}>{`Intution`}</a>{` (read all parts).`}</p>
    <p>{`Longest increasing subsequence problem (`}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=4fQJGoeW5VE"
      }}>{`watch`}</a>{`).`}</p>
    <p>{`Paths on a grid problem (`}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=M8BYckxI8_U"
      }}>{`watch`}</a>{`).`}</p>
    <p>{`Knapsack Problem (watch `}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=EH6h7WA7sDw"
      }}>{`this`}</a>{` or `}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=xOlhR_2QCXY"
      }}>{`this`}</a>{`)`}</p>
    <p>{`Subset sum problem (`}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=s6FhG--P7z0"
      }}>{`watch`}</a>{`)`}</p>
    <p>{`Watch `}<a parentName="p" {...{
        "href": "https://www.youtube.com/playlist?list=PLqM7alHXFySGbXhWx7sBJEwY2DnhDjmxm"
      }}>{`this`}</a>{` full playlist by Geeksforgeeks.`}</p>
    <h2 {...{
      "id": "graph-algorithms"
    }}>{`Graph Algorithms`}</h2>
    <p>{`Basics of graph. Watch `}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=ZHqQDA3be-k"
      }}>{`here`}</a>{` or `}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=HmQR8Xy9DeM"
      }}>{`here`}</a>{` or from Humblefool’s
mycodeschool(part `}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=gXgEDyodOJU&index=39&list=PL2_aWCzGMAwI3W_JlcBbtYTwiQSsOTa6P&t=0s"
      }}>{`basics`}</a>{` and `}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=AfYqN3fGapc&index=40&list=PL2_aWCzGMAwI3W_JlcBbtYTwiQSsOTa6P&t=0s"
      }}>{`properties`}</a>{` {highly recommended})`}</p>
    <p>{` Graph representation using `}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=k1wraWzqtvQ&index=43&list=PL2_aWCzGMAwI3W_JlcBbtYTwiQSsOTa6P&t=0s"
      }}>{`edge list, adjacency matrix, adjacency
lists`}</a>{` and `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Incidence_matrix"
      }}>{`incidence matrix`}</a>{`.`}</p>
    <p>{`Graph Transversal (BFS & DFS `}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=zaBhtODEL0w"
      }}>{`watch`}</a>{`, `}<a parentName="p" {...{
        "href": "https://visualgo.net/en/dfsbfs?slide=1"
      }}>{`visualize`}</a>{` and
implementation`}<a parentName="p" {...{
        "href": "https://brilliant.org/wiki/breadth-first-search-bfs/"
      }}>{`BFS`}</a>{` & `}<a parentName="p" {...{
        "href": "https://brilliant.org/wiki/depth-first-search-dfs/"
      }}>{`DFS`}</a>{`). Problems on `}<a parentName="p" {...{
        "href": "http://www.spoj.com/problems/tag/bfs"
      }}>{`BFS`}</a>{` & `}<a parentName="p" {...{
        "href": "http://www.spoj.com/problems/tag/dfs"
      }}>{`DFS`}</a>{`.`}</p>
    <p><a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=5wFyZJ8yH9Q"
      }}>{`Strongly Connected Components`}</a></p>
    <p>{` `}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=UTgfSPQpJDw"
      }}>{`Biconnectivity`}</a>{`, `}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=zxa4ZXnbMVw"
      }}>{`Tarzan’s algorithm`}</a>{`(`}<a parentName="p" {...{
        "href": "https://commons.wikimedia.org/wiki/File:Tarjan%27s_Algorithm_Animation.gif"
      }}>{`visualization`}</a>{`) for finding bridges.`}</p>
    <p>{`Dijkstra’s Algorithm (`}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=GazC3A4OQTE"
      }}>{`watch`}</a>{`, `}<a parentName="p" {...{
        "href": "https://www.cs.usfca.edu/~galles/visualization/Dijkstra.html"
      }}>{`visualize`}</a>{` and `}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=d6ZFqjH63vo"
      }}>{`implement`}</a>{`  `}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=0nVYi3o161A"
      }}>{`example`}</a>{`)`}</p>
    <p>{`Bellman Ford algorithm (`}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=lyw4FaxrwHg"
      }}>{`watch`}</a>{`, `}<a parentName="p" {...{
        "href": "https://www-m9.ma.tum.de/graph-algorithms/spp-bellman-ford/index_en.html"
      }}>{`visualize with example`}</a>{`)`}</p>
    <p>{`Floyd–Warshall Algorithm (`}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=KQ9zlKZ5Rzc"
      }}>{`watch`}</a>{`, `}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=VoNMulNisiU"
      }}>{`visualize`}</a>{` (`}<a parentName="p" {...{
        "href": "https://www.cs.usfca.edu/~galles/visualization/Floyd.html"
      }}>{`another`}</a>{`) and `}<a parentName="p" {...{
        "href": "https://rosettacode.org/wiki/Floyd-Warshall_algorithm"
      }}>{`implement`}</a>{`
and `}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=B06q2yjr-Cc"
      }}>{`on undirected path`}</a>{`.`}</p>
    <p>{`Directed Acyclic Graphs (`}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=eL-KzMXSXXI"
      }}>{`Topological Sort`}</a>{` and `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Topological_sorting"
      }}>{`implementation`}</a>{`)
`}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=NbsnlRMrOOw"
      }}>{`Dynamic Programming`}</a>{` for shortest path.`}</p>
    <p>{`Minimum Spanning Trees (`}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=tKwnms5iRBU"
      }}>{`watch`}</a>{`). `}<a parentName="p" {...{
        "href": "https://visualgo.net/en/mst"
      }}>{`Prim and Kruskal Visualization`}</a></p>
    <p>{` `}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=1V_6nUUNoms"
      }}>{`Euler’s tour algorithm`}</a>{`.`}</p>
    <p><a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=sSgI072tN5k"
      }}>{`Maximum flow using Ford Fulkerson Method`}</a>{`.`}</p>
    <h2 {...{
      "id": "algorithms-design-topics"
    }}>{`Algorithms Design Topics`}</h2>
    <p>{`Bit-Parallel Algorithms (`}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=4ZqIddyXK9o"
      }}>{`Hamming Distances`}</a>{`), (`}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=M8BYckxI8_U"
      }}>{`Counting Subgrids`}</a>{`)`}</p>
    <p><a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=3MpzavN3Mco"
      }}>{`Amortized Analysis`}</a></p>
    <p>{`Ternary Search (`}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Ternary_search"
      }}>{`read`}</a>{` and `}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=JaO8cU9WlWg"
      }}>{`implement`}</a>{`)`}</p>
    <h2 {...{
      "id": "tree-algorithms"
    }}>{`Tree Algorithms`}</h2>
    <p><a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=qH6yxkw0u78&t=0s&list=PL2_aWCzGMAwI3W_JlcBbtYTwiQSsOTa6P&index=26"
      }}>{`Introduction`}</a>{` (`}<a parentName="p" {...{
        "href": "https://www.youtube.com/playlist?list=PL2_aWCzGMAwI3W_JlcBbtYTwiQSsOTa6P"
      }}>{`mycodeschool`}</a>{`)`}</p>
    <p>{`Tree transversal (`}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=gm8DUJJhmY4"
      }}>{`Binary tree transversal`}</a>{`) (`}<a parentName="p" {...{
        "href": "https://www.youtube.com/playlist?list=PLfBJlB6T2eOsET4tlfcLs7oXR7kCyt1xc"
      }}>{`DP`}</a>{`) (`}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Tree_traversal"
      }}>{`wiki`}</a>{`)`}</p>
    <p>{`Diameter of the binary tree (`}<a parentName="p" {...{
        "href": "https://www.geeksforgeeks.org/diameter-of-a-binary-tree-in-on-a-new-method/"
      }}>{`in O(n) time`}</a>{`) (`}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=aqfTvKWWHWI"
      }}>{`watch`}</a>{`)`}</p>
    <p>{`Lowest common ancestor in tree on O(1). (`}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=HeeyUZmaZg0"
      }}>{`watch`}</a>{`)`}</p>
    <p>{`Centroid decomposition (`}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=-Lgda-6_AiY"
      }}>{`watch`}</a>{`) (`}<a parentName="p" {...{
        "href": "https://www.geeksforgeeks.org/centroid-decomposition-of-tree/"
      }}>{`read`}</a>{`) (`}<a parentName="p" {...{
        "href": "http://codeforces.com/blog/entry/52492"
      }}>{`problems`}</a>{`)`}</p>
    <p>{`Heavy light decomposition (`}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=nDLe6_sPSfs"
      }}>{`advanced`}</a>{`) (`}<a parentName="p" {...{
        "href": "https://wcipeg.com/wiki/Heavy-light_decomposition"
      }}>{`read`}</a>{`)`}</p>
    <h2 {...{
      "id": "mathematics"
    }}>{`Mathematics`}</h2>
    <p>{`Read whole book ‘`}<a parentName="p" {...{
        "href": "https://github.com/czgdp1807/resourcesandproblems/blob/master/Elementary%20Number%20Theory%20with%20Programming.pdf"
      }}>{`Elementary Number Theory with Programming`}</a>{`’.`}</p>
    <p><a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=CCr-p1tInwQ"
      }}>{`Watch`}</a>{` this if you have less time. A video by O’Reilly.`}</p>
    <p>{`Game theory `}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=JT8ZuJey3s0"
      }}>{`intro`}</a>{`. `}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=niMjxNtiuu8"
      }}>{`NIM game`}</a>{`. Spragur-Grundy theorem.(`}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=GRlGknQEOW8"
      }}>{`watch`}</a>{`)`}</p>
    <h2 {...{
      "id": "advanced-graph-algorithms"
    }}>{`Advanced Graph Algorithms`}</h2>
    <p>{`Strong Connectivity - ​`}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=9Wbej7Fy5Lw"
      }}>{`Kosaraju’s Algorithm`}</a>{` (`}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Kosaraju%27s_algorithm"
      }}>{`wiki`}</a>{`), 2SAT Problem
(`}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=0nNYy3rltgA"
      }}>{`watch`}</a>{` approx. 2hr)`}</p>
    <p>{`Complete Paths - Eulerian Paths (`}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=AwsMTEl79wI"
      }}>{`basics`}</a>{`) (`}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Eulerian_path"
      }}>{`wiki`}</a>{`), Hamiltonian Path
(`}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=9Fdn17CNy2U"
      }}>{`basics`}</a>{`) (`}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Hamiltonian_path"
      }}>{`wiki`}</a>{`), Applications - De Bruijn sequence(`}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=iPLQgXUiU14"
      }}>{`watch`}</a>{`), Knight’s
tour(`}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=ab_dY3dZFHM"
      }}>{`numberphile`}</a>{`)`}</p>
    <p>{`Maximum Flows - (`}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=VYZGlgzr_As"
      }}>{`MIT`}</a>{`) (`}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=Tl90tNtKvxs"
      }}>{`Ford–Fulkerson Algorithm`}</a>{`)`}</p>
    <p>{`##App developed by Me `}</p>
    <p><a parentName="p" {...{
        "href": "https://play.google.com/store/apps/details?id=com.algomaster.app"
      }}>{`https://play.google.com/store/apps/details?id=com.algomaster.app`}</a></p>
    <p>{`##Cpp Books (to be added more)`}</p>
    <p><a parentName="p" {...{
        "href": "https://github.com/inductor69/Cpp-Books/blob/master/cp1.pdf"
      }}>{`https://github.com/inductor69/Cpp-Books/blob/master/cp1.pdf`}</a></p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
export const tableOfContents = (components={}) => [
  {
    id: "is-this-document-for-you",
    level: 2,
    title: "Is this document for you?",
    children: [
        
      ]
  },
{
    id: "disclaimer",
    level: 2,
    title: "Disclaimer",
    children: [
        
      ]
  },
{
    id: "introduction",
    level: 2,
    title: "Introduction",
    children: [
        
      ]
  },
{
    id: "programming-techniques",
    level: 2,
    title: "Programming Techniques",
    children: [
        
      ]
  },
{
    id: "time-complexity",
    level: 2,
    title: "Time Complexity",
    children: [
        
      ]
  },
{
    id: "sorting-and-searching",
    level: 2,
    title: "Sorting and Searching",
    children: [
        
      ]
  },
{
    id: "data-structures",
    level: 2,
    title: "Data Structures",
    children: [
        
      ]
  },
{
    id: "graph-algorithms",
    level: 2,
    title: "Graph Algorithms",
    children: [
        
      ]
  },
{
    id: "algorithms-design-topics",
    level: 2,
    title: "Algorithms Design Topics",
    children: [
        
      ]
  },
{
    id: "tree-algorithms",
    level: 2,
    title: "Tree Algorithms",
    children: [
        
      ]
  },
{
    id: "mathematics",
    level: 2,
    title: "Mathematics",
    children: [
        
      ]
  },
{
    id: "advanced-graph-algorithms",
    level: 2,
    title: "Advanced Graph Algorithms",
    children: [
        
      ]
  }
]

export const frontMatter = {
  "slug": "Competitive-Programming",
  "title": "Competitive-Programming",
  "description": "Complete roadmap for Competitive Programming.",
  "banner": "banner.jpg",
  "bannerPlaceholder": "banner.jpg",
  "bannerAlt": "Complete roadmap for Competitive Programming.",
  "tags": [
    "competitive",
    "programming",
    "algorithm"
  ],
  "date": "2020-08-10T00:00:00.000Z",
  "readTime": "00:03:00:00"
}

